import React from "react";
import { DialogContentText } from "@material-ui/core";
import { withSnackbar } from "notistack";
import Popup from "components/popup";
import { toast } from "react-toastify";
import { withRouter } from "react-router-dom";
import { deleteSupervisorMentor } from "repository/actions/data/dashboard/students";

export default withSnackbar(
  withRouter(function (props) {
    const {
      isOpen,
      setClose,
      student,
      mentorIndex,
      mentors,
      user,
      setStudent,
      getStudent,
      editStudent,
    } = props;
    const [saveLoading, setSaveLoading] = React.useState(false);

    const handleDeleteMentor = () => {
        
      if (user && user != null) {
        setSaveLoading(true);

        setSaveLoading(true);
        toast.dark(`Removing Mentor`);
        deleteSupervisorMentor(
          student._id,
          mentors[mentorIndex].person._id,
          mentors[mentorIndex].course._id,
          "mentor",
          user.idToken
        )
          .then((result) => {
            getStudent(student._id, user.idToken).then(getStudentResult => {
              setStudent(getStudentResult);
              
            })
            setSaveLoading(false);
            toast.success(`Mentor Removed`);
            setClose();
            // setStudent(result);
            
          })
          .catch((error) => {
            toast.error("Oops! Something went wrong.");
            toast.dark(error.message);
            setSaveLoading(false);
          });
      }
    };

    return (
      <Popup
        title="Remove Mentor"
        isOpen={isOpen}
        handleCancel={() => setClose()}
        handleAction={() => handleDeleteMentor()}
        actionButtonTitle="Yes, I'm sure."
        disabled={saveLoading}
        content={
          <div>
            <DialogContentText>
              Are you sure you want to remove this mentor ?
            </DialogContentText>
          </div>
        }
      />
    );
  })
);
